import React, {
  ComponentProps,
  ComponentPropsWithRef,
  ComponentType,
  useCallback,
} from 'react';

import { Icon, BulldozerIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import PlanTaskEntityMenuItemLabel from './PlanTaskEntityMenuItemLabel/PlanTaskEntityMenuItemLabel';
import EntityMenuItem from '../../../../../EntityMenuItem';
import { usePlanTaskLink } from '../../hooks';
import { TaskEntity } from '../../types';

type PlanTaskEntityBlockProps = ComponentProps<
  ComponentType<{ entity: TaskEntity }>
>;

const PlanTaskEntityMenuItem = ({
  entity: { task },
  ...rest
}: PlanTaskEntityBlockProps) => {
  const planTaskLink = usePlanTaskLink(task);

  const renderIcon = useCallback(
    (props: ComponentPropsWithRef<typeof Icon>) => (
      <BulldozerIcon size={20} color={theme.colors.charcoal500} {...props} />
    ),
    [],
  );

  return (
    <EntityMenuItem
      {...rest}
      link={planTaskLink}
      renderIcon={renderIcon}
      label={<PlanTaskEntityMenuItemLabel task={task} />}
    />
  );
};

export default PlanTaskEntityMenuItem;
